import { Component } from '@angular/core';


// Empty Component for router sink
@Component({ template: '' })
export class HybridizerComponent {}
